import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

const Footer = ({
  tutorialLink,
  hintLink,
  gameId,
  isLoginRequired,
  hideContinueBtn,
  totalAnswersLenght,
  hasHints,
  hideShopAccountTutorial = true,
  setNewSelectedMode,
  hideGameModeSelection = true,
}) => {
  const [gameModeData, setGameModeData] = useState({
    game_id: '',
    has_game_mode: false,
    game_mode: [],
  });

  // ** UI State **
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showSubMenu, setShowSubMenu] = useState(false);  

  // ** Refs **
  const menuRef = useRef(null);
  const subMenuRef = useRef(null);

  // ** Routing **
  const location = useLocation();
  const isProfile = location.pathname.includes('profile');

  // ** Local Storage **
  const selectedModes =
    JSON.parse(localStorage.getItem('selectedGameMode')) || [];
  const currentMode = selectedModes.find(
    (res) => res.gameId === gameModeData.game_id
  );

  // ** Load Game Mode **
  const LoadGameMode = () => {
    const fs = JSON.parse(localStorage.getItem('gameFinalScreen'));
    const gameMode = fs?.find((item) => item._id === gameId)?.game_modes ?? {}

    if (gameMode) {
      setGameModeData({
        game_id: gameId,
        has_game_mode: true,
        game_mode: gameMode,
      })

    }
  };

  // ** Save Game Mode Selection **
  function saveGameModeSelection(gameId, mode) {
    let updatedList = [...selectedModes];
    const newEntry = {
      gameId,
      gameMode: mode?.key,
      gameModeName: mode?.name,
      isSetDefault: false,
    };

    const index = updatedList.findIndex((x) => x.gameId === gameId);
    if (index !== -1) updatedList[index] = newEntry;
    else updatedList.push(newEntry);

    localStorage.setItem('selectedGameMode', JSON.stringify(updatedList));
    return newEntry;
  }

  // ** Click Outside **
  const handleClickOutside = (e) => {
    if (isMenuOpen && !menuRef.current?.contains(e.target)) {
      setIsMenuOpen(false);
      setShowSubMenu(false);
    }

    if (showSubMenu && !subMenuRef.current?.contains(e.target)) {
      setShowSubMenu(false);
    }
  };

  // ** Handle Logout **
  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.clear();
    if (
      location.pathname.includes('/congrats') ||
      location.pathname === '/drawer'
    ) {
      window.location.href = '/auth';
    } else {
      window.location.reload();
    }
  };

  // ** UI Components **
  const MenuButton = ({ onClick, icon, label }) => (
    <div onClick={onClick}>
      <>
          <img src={icon} alt='' />
          <span>{label}</span>
        </>
    </div>
  );

  const HintButton = () => (
    <div onClick={() => hasHints && hintLink()}>
      <img
        src={
          hasHints
            ? '/assets/HintsIcon_white.svg'
            : '/assets/HintsIcon_Gray.svg'
        }
        className='hint__img__footer'
        alt=''
      />
      <span>HINT</span>
    </div>
  );

  // ** Use Effects **
  useEffect(() => {
    LoadGameMode();
  }, []);

  useEffect(() => {
    if (isMenuOpen || showSubMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMenuOpen, showSubMenu]);

  // **  MAIN FOOTER UI — GAME MODE VERSION **
  if (gameModeData.has_game_mode) {
    return (
      <>
        {isMenuOpen && (
          <div className='footer__dropdown' ref={menuRef}>
            <button
              className='footer__close'
              onClick={() => setIsMenuOpen(false)}
            >
              <i className='fa fa-angle-down'></i>
            </button>

            <div className='footer__menu'>
              {hideShopAccountTutorial && (
              <button onClick={() => ( window.location.href = tutorialLink)}>
                TUTORIAL
              </button>
              )}
              {
                !hideGameModeSelection && (
                  <div className='footer__submenu'>
                    <button
                      className='footer__submenu__btn'
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowSubMenu(!showSubMenu);
                      }}
                    >
                      GAME MODE <i className='fa fa-angle-right'></i>
                    </button>

                    { showSubMenu && (
                      <div className='footer__submenu__list' ref={subMenuRef}>
                        {gameModeData?.game_mode?.map((mode, idx) => {
                          const isActive = mode.key === currentMode?.gameMode;

                          return (
                            <button
                              key={idx}
                              onClick={() => {
                                const updated = saveGameModeSelection(
                                  gameModeData.game_id,
                                  mode
                                );
                                setNewSelectedMode?.(updated);
                                setShowSubMenu(false);
                                setIsMenuOpen(false);
                              }}
                              style={{
                                backgroundColor: isActive ? 'white' : 'transparent',
                                color: isActive ? 'black' : 'inherit',
                                textAlign: 'center',
                              }}
                            >
                              {mode.name}
                            </button>
                          );
                        })}
                      </div>
                    )}
                  </div>
                )}

              <button
                onClick={() => {
                  localStorage.setItem('backLink', window.location.href);
                  window.location.href = '/profile';
                }}
              >
                ACCOUNT
              </button>
              <button onClick={handleLogout}>LOGOUT</button>
            </div>
          </div>
        )}

        {/* Bottom Bar */}
        <div className='fixed__div'>
          <div className='footer__container__loginNotRequired'>
            <MenuButton
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              icon='/assets/footer_menu.svg'
              label='MENU'
            />

            <HintButton />
          
            { hideShopAccountTutorial && (
              <MenuButton
                onClick={() => window.open('https://escapely.com/shop/', '_blank')}
                icon='/assets/ShopIcon_white.svg'
                label='SHOP'
              />
            )}
          </div>
        </div>
      </>
    );
  }

  // **  LOGIN REQUIRED FOOTER **
  if (isLoginRequired) {
    return (
      <div className='fixed__div'>
        <div className='footer__container'>
          <MenuButton
            onClick={() => {
              localStorage.setItem('backLink', window.location.href);
              window.location.href = '/profile';
            }}
            icon={
              isProfile
                ? '/assets/ProfilePicIcon.svg'
                : '/assets/AccountIcon_white.svg'
            }
            label='ACCOUNT'
          />

          <MenuButton
            onClick={() => window.open('https://escapely.com/shop/', '_blank')}
            icon='/assets/ShopIcon_white.svg'
            label='SHOP'
          />

          <HintButton />

          {hideShopAccountTutorial && (<MenuButton
            onClick={() => (window.location.href = tutorialLink)}
            icon='/assets/TutorialIcon_white.svg'
            label='TUTORIAL'
          />
          )}

          <MenuButton
            onClick={handleLogout}
            icon='/assets/LogoutIcon_white.svg'
            label='LOGOUT'
          />
        </div>
      </div>
    );
  }

  // **  DEFAULT FOOTER (NO LOGIN) **
  return (
    <div className='fixed__div'>
      <div className='footer__container__loginNotRequired'>
        {hideShopAccountTutorial && (
        <MenuButton
          onClick={() => window.open('https://escapely.com/shop/', '_blank')}
          icon='/assets/ShopIcon_white.svg'
          label='SHOP'
        />
        )}
        <HintButton />

        {hideShopAccountTutorial && (
        <MenuButton
          onClick={() => (window.location.href = tutorialLink)}
          icon='/assets/TutorialIcon_white.svg'
          label='TUTORIAL'
        />
        )}
      </div>
    </div>
  );
};

export default Footer;
